var exports = {
  "Y": "Product__njOtv1",
};

module.exports = exports;
